// 环境的切换
import axios from 'axios';

// function addkey(value) {
// 	if (typeof value === 'object') {
// 		value.header = 'AHSCXB'
// 	}
// 	return value
	
// }

if (process.env.NODE_ENV == 'development') { 
	axios.defaults.baseURL = "apinet"
			axios.defaults.timeout = 10000;
			
			axios.interceptors.request.use(    
					config => {        
			
							var token =  localStorage.getItem('token')
							token && (config.headers.token = token)
							// config.headers['Content-Type'] = 'application/raw'
							config.headers['domainId'] = 'AHSCXB'
							return config;    
					},    
					error => {        
							return Promise.error(error);    
			})
			
			var get =  function (url, params){    
				
					return new Promise((resolve, reject) =>{        
							axios.get("/portal/api" + url, {            
									params: params        
							}).then(res => {
									resolve(res.data);
							}).catch(err =>{
																	resolve(err.response.data)        
					})    
			});}
			var get_res = function (url, params={}){    
				
				// console.log('接口参数中的params',params);
					return new Promise((resolve, reject) =>{        
							axios.get("/pub/api" + url, {            
									params: params        
							}).then(res => {
									resolve(res.data);
							}).catch(err =>{
																	resolve(err.response.data)        
					})    
			});}
			
			var put = function (url, params){
				
					return new Promise((resolve, reject) =>{        
							axios.put("/pub/api" + url,            
									 params    ,
									 {
										headers: {
												'Content-Type': 'application/json',
												'domainId': 'AHSCXB'
										}
									 }
							).then(res => {
									resolve(res.data);
							}).catch(err =>{
																	resolve(err.response.data)        
					})    
			});}
			
			// 梦已逝、莫相思:
			// http://36.7.79.32:18080/api/docs/1881949/getAttach    http://36.7.79.32:18080/api/docs/1881949/attchment
			
			var get_video =  function (params){    
				
					return new Promise((resolve, reject) =>{        
							axios.get("/pub/api/docs/" + params + "/attchment", { 
							}).then(res => {
									resolve(res.data);
							}).catch(err =>{
																	resolve(err.response.data)        
					})    
			});}
			
			
			var post = function (url, params) {
				
					return new Promise((resolve, reject) => {
							 axios.post("/portal/api"+url, params)
							.then(res => {
									resolve(res.data);
							})
							.catch(err =>{
																	resolve(err.response.data)
							})
					});
			}
			
			var delete_api = function (url, params) {
					return new Promise((resolve, reject) => {
							 axios.delete("/pub/api"+url, {params})
							.then(res => {
									resolve(res.data);
							})
							.catch(err =>{
									resolve(err.response.data)
							})
					});
			}
			
			var post_res  =  function (url, params) {
				return new Promise((resolve, reject) => {
						 axios.post("/pub/api" + url, params)
						.then(res => {
								resolve(res.data);
						})
						.catch(err =>{
								resolve(err.response.data)
								// console.log(err.response)
						})
				})
			}
			var post_res_bold  =  function (url, params) {
				return new Promise((resolve, reject) => {
						 axios.post("/pub/api" + url, params, {responseType: 'buffer'})
						.then(res => {
							console.log('111', res)
								resolve(res);
						})
						.catch(err =>{
								resolve(err.response.data)
								// console.log(err.response)
						})
				})
			}
			var addDevote  =  function (url, params) {
				return new Promise((resolve, reject) => {
						 axios.post("/addDevote" + url, params)
						.then(res => {
								resolve(res.data);
						})
						.catch(err =>{
								resolve(err.response.data)
								// console.log(err.response)
						})
				})
			}
    } else if (process.env.NODE_ENV == 'production') {
			let baseUrl = "http://www.tpahw.com"
			if (window.location.href.indexOf('.com') > -1) {
				baseUrl = "http://www.tpahw.com"
			} else {
				baseUrl = 'http://www.tpahw.cn'
			}
	
	// 下面是build之后下面是build之后下面是build之后下面是build之后下面是build之后
    axios.defaults.timeout = 10000;
    axios.interceptors.request.use(
        config => {        
    
            var token =  localStorage.getItem('token')
            token && (config.headers.token = token); 
						config.headers['domainId'] = 'AHSCXB'
            return config;         
        },    
        error => {        
            return Promise.error(error);    
    })
    
    var get = function(url, params){    
        return new Promise((resolve, reject) =>{        
            axios.get(baseUrl+ "/portal/api" + url, {            
                params: params        
            }).then(res => {
                resolve(res.data);
            }).catch(err =>{
                								resolve(err.response.data)        
        })    
    });}
    var get_res = function(url, params){    
        return new Promise((resolve, reject) =>{        
            axios.get(baseUrl+"/pub/api" + url, {            
                params: params        
            }).then(res => {
                resolve(res.data);
            }).catch(err =>{
                								resolve(err.response.data)        
        })    
    });}
		
		var put = function (url, params){
				return new Promise((resolve, reject) =>{        
						axios.put(baseUrl+"/pub/api" + url,            
								params   ,
								{
									headers: {
											'Content-Type': 'application/json',
											'domainId': 'AHSCXB'
									}
								}
						).then(res => {
								resolve(res.data);
						}).catch(err =>{
																resolve(err.response.data)        
				})    
		});}
    
    // 梦已逝、莫相思:
    // http://36.7.79.32:18080/api/docs/1881949/getAttach    http://36.7.79.32:18080/api/docs/1881949/attchment
    
    var get_video =  function (params){    
        return new Promise((resolve, reject) =>{        
            axios.get(baseUrl+"/pub/api/docs/" + params + "/attchment", { 
            }).then(res => {
                resolve(res.data);
            }).catch(err =>{
                								resolve(err.response.data)        
        })    
    });}
    
    
    var post = function (url, params) {
        return new Promise((resolve, reject) => {
             axios.post(baseUrl+"/portal/api"+url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err =>{
                								resolve(err.response.data)
            })
        });
    }
		
		var delete_api = function (url, params) {
			// console.log(params)
				return new Promise((resolve, reject) => {
						 axios.delete(baseUrl+"/pub/api"+url, params)
						.then(res => {
								resolve(res.data);
						})
						.catch(err =>{
																resolve(err.response.data)
						})
				});
		}
    var post_res  =   function (url, params) {
        return new Promise((resolve, reject) => {
             axios.post(baseUrl+"/pub/api" + url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err =>{
                								resolve(err.response.data)
            })
        });
    }
		var post_res_bold  =   function (url, params) {
		    return new Promise((resolve, reject) => {
		         axios.post(baseUrl+"/pub/api" + url, params, {responseType: 'blob'  })
		        .then(res => {
		            resolve(res.data);
		        })
		        .catch(err =>{
		            								resolve(err.response.data)
		        })
		    });
		}
		 // 
}

export {
	post_res,post,get_video,get_res,get,delete_api,put,addDevote,post_res_bold
}


